export default "__VITE_ASSET__DFO4Dsv2__"